import { ReactNode, useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { FaRegCommentAlt } from "react-icons/fa";
import { Popover, Wrapper } from "./style";

interface IProps {
  children: ReactNode;
  popover?: ReactNode;
  iconSize?: number;
}

const MARGEM = 8;

export function PopoverHover({ children, popover, iconSize = 14 }: IProps) {
  const [show, setShow] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const iconRef = useRef<HTMLSpanElement>(null);
  const popoverRef = useRef<HTMLDivElement>(null);

  const posicionar = () => {
    const icone = iconRef.current;
    if (!icone) return;

    const rect = icone.getBoundingClientRect();
    const alturaPopover = popoverRef.current?.offsetHeight ?? 0;
    const alturaJanela = window.innerHeight;

    let top = rect.top;
    if (top + alturaPopover + MARGEM > alturaJanela) {
      top = Math.max(MARGEM, alturaJanela - alturaPopover - MARGEM);
    }

    setCoords({ top, left: rect.left });
  };

  useLayoutEffect(() => {
    if (show) posicionar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  if (!popover) return <>{children}</>;

  return (
    <Wrapper>
      {children}
      <span
        ref={iconRef}
        style={{ display: "inline-flex" }}
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
      >
        <FaRegCommentAlt
          size={iconSize}
          color="#6E6E6E"
          style={{ cursor: "pointer", flexShrink: 0 }}
        />
        {show &&
          createPortal(
            <Popover ref={popoverRef} top={coords.top} left={coords.left}>
              {popover}
            </Popover>,
            document.body,
          )}
      </span>
    </Wrapper>
  );
}
